// extracted by mini-css-extract-plugin
module.exports = {"company-label":"_02712f2b3b--company-label--I_Ot4"};